<template>
  <div class="shared-step-editor-header-name">
    <span> <slot /></span>
    {{ name }}
  </div>
</template>

<script>
export default {
  props: {
    name: String,
  },
};
</script>

<style scoped lang="scss">
.shared-step-editor-header-name {
  display: flex;
  gap: 10px;
  line-height: 16px;
  align-items: center;
  margin-left: 20px;
  color: #ffffff;
  &__icon {
    width: 18px;
  }
}
</style>
